import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';

import { ConfigurationState } from './configuration.state';

export namespace ConfigurationSelectors {
  export const configurationState = (state: AppState): ConfigurationState => state.configuration;

  export const selectFeaturesBaseUri = createSelector(
    configurationState,
    (state): string => state.featuresBaseUri
  );
}
